module.exports = __webpack_public_path__ + "img/modal-light.852bdf98.png";